// ── Single source of truth for "missing field" indicators ──
// Used by both the sidebar status indicators (red/teal icons) and by the
// system setup pages to outline which specific fields are causing the alert.
//
// Each section returns a map: { fieldKey: 'required' | 'recommended' }.
// Only entries for fields that are currently missing are included. Empty/absent
// = field is satisfied.

const isFilled = (v) => {
  if (v === null || v === undefined) return false;
  if (typeof v === 'string') return v.trim().length > 0;
  return Boolean(v);
};

export function getMissingFields(brand, domainInput = '') {
  const empty = { branding: {}, legal: {}, tracking: {}, quoter: {} };
  if (!brand) return empty;

  const out = { branding: {}, legal: {}, tracking: {}, quoter: {} };

  // ── Branding (Customize Branding page) ──
  if (!isFilled(brand.title))                              out.branding.title = 'required';
  if (!isFilled(brand.email))                              out.branding.email = 'required';
  if (!isFilled(brand.phone))                              out.branding.phone = 'required';
  if (!isFilled(brand.website_url))                        out.branding.website_url = 'required';
  if (!isFilled(brand.subdomain_alias) && !isFilled(brand.subdomain)) out.branding.subdomain = 'required';
  if (!isFilled(brand.timezone))                           out.branding.timezone = 'required';
  if (!isFilled(brand.logo_filename))                      out.branding.logo = 'required';
  if (!isFilled(brand.details?.agent?.name))               out.branding.agent_name = 'recommended';
  if (!isFilled(brand.favicon_filename))                   out.branding.favicon = 'recommended';
  if (!isFilled(brand.details?.agent?.filename))           out.branding.agent_photo = 'recommended';

  // ── Disclaimers & Legal ──
  if (!isFilled(brand.details?.legal_links?.privacy_policy)) out.legal.privacy_policy = 'required';
  if (!isFilled(brand.title_legal))                        out.legal.title_legal = 'recommended';
  if (!isFilled(brand.email_internal))                     out.legal.email_internal = 'recommended';
  if (!isFilled(brand.phone_internal))                     out.legal.phone_internal = 'recommended';

  // ── Tracking & Analytics ──
  if (!isFilled(brand.details?.tracking?.ga_id))           out.tracking.ga_id = 'recommended';

  // ── Funnel & Quoter (custom domain — recommended only on paid plans) ──
  const planId = brand?.plan_id || brand?.brand_plan_id;
  const isBasicOrStarter = planId === 1 || planId === 7 || planId === '1' || planId === '7';
  if (!isBasicOrStarter && !isFilled(brand.custom_domain) && !isFilled(domainInput)) {
    out.quoter.custom_domain = 'recommended';
  }

  return out;
}

// Aggregate the per-field map into the page-level summary the sidebar uses.
export function getPageStatus(brand, domainInput = '') {
  const missing = getMissingFields(brand, domainInput);
  const summarize = (sectionMap) => ({
    requiredMissing: Object.values(sectionMap).some((v) => v === 'required'),
    recommendedMissing: Object.values(sectionMap).some((v) => v === 'recommended'),
  });
  return {
    branding: summarize(missing.branding),
    legal: summarize(missing.legal),
    tracking: summarize(missing.tracking),
    quoter: summarize(missing.quoter),
  };
}
